import clsx from 'clsx'
import type { PropsWithChildren } from 'react'
import {
  detailPanel,
  detailPanelInner,
  detailPanelOpen
} from '~/components/Scopes/Actions/Actions.css'

type DetailPanelProps = PropsWithChildren<{
  isOpen: boolean
}>

export const DetailPanel = ({ isOpen, children }: DetailPanelProps) => (
  <div className={clsx(detailPanel, isOpen && detailPanelOpen)}>
    <div className={detailPanelInner}>{children}</div>
  </div>
)
